// V70 — Split from monolithic siteData.js for maintainability. Re-exported
// by ../siteData.js barrel — every consumer keeps importing from '../data/siteData'.
//
// Do not import this file directly from feature code — import from siteData instead.

// Optimized logo served from /app/frontend/public — 24 KB (was 1.6 MB on the
// external customer-assets CDN which timed out on 4G/LTE and rendered as a
// broken image icon on some Android browsers). Local hosting means the logo
// always loads with the site itself, no cross-origin latency, no CDN drop.
export const LOGO_URL = "/logo-anand-tutorials.png";

// Alternate (used in dark sections where the dark-bg variant is desired)
export const LOGO_URL_DARK_BG = "/logo-anand-tutorials-dark.png";

// Absolute URL for schema.org JSON-LD (must be absolute for search engines)
export const LOGO_URL_ABSOLUTE =
    "https://anandtutorials.com/logo-anand-tutorials.png";

// V171 — Added official business email alongside the legacy support email.
// Both are shown in the public UI; SEO/JSON-LD schema still uses the legacy
// gmail as the canonical contactPoint (per approved scope — do not touch).
export const BUSINESS_EMAIL = "info@anandtutorials.com";
export const SUPPORT_EMAILS = [
 "anandhometutorials@gmail.com",
 "info@anandtutorials.com",
];

export const HEAD_OFFICE = {
 label: "Head Office",
 address: "Ghadi Chowk, Vijay Nagar, Jabalpur, Raksha, Madhya Pradesh 482002",
 email: "anandhometutorials@gmail.com",
 businessEmail: "info@anandtutorials.com",
 phones: ["+91 7000530316", "+91 9993305574"],
 // Official Google Maps short link — canonical for "Get Directions" CTAs
 mapUrl: "https://maps.app.goo.gl/86xQV7m8AvTJ42XPA?g_st=ac",
 // iframe-embeddable variant for map widgets (short links can't be embedded)
 mapEmbed:
 "https://www.google.com/maps?q=Anand+Tutorials+Ghadi+Chowk+Vijay+Nagar+Jabalpur+Raksha+Madhya+Pradesh+482002&output=embed",
 // Geo coordinates of the Head Office (Ghadi Chowk, Vijay Nagar, Jabalpur)
 geo: { lat: 23.1815, lng: 79.9864 },
 postalCode: "482002",
 city: "Jabalpur",
 state: "Madhya Pradesh",
 countryCode: "IN",
};

export const BRANCHES = [
 {
 label: "Branch 01 — Pachpedi",
 address:
 "Block D1 Aman Apartment, near SP Bungalow, Dwarka Nagar Ward, Pachpedi, South Civil Lines, Jabalpur, Madhya Pradesh 482001",
 },
 {
 label: "Branch 02 — Gwarighat",
 address: "7 Forest Quarter, Gwarighat Rd, Awadhpuri Colony, Jabalpur, Madhya Pradesh 482008",
 },
];

export const SOCIAL = {
 instagram: "https://www.instagram.com/anandtutorialsofficial",
 facebook: "https://www.facebook.com/anandtutorialsofficial",
 linkedin: "",
 youtube: "",
 twitter: "",
 whatsapp: "917000530316", // V68 — Global WhatsApp destination for ALL click-through (city phone numbers displayed as text remain unchanged).
};
export const PAYMENT_INFO = {
 accountHolder: "Anand Home Tutorials",
 accountNumber: "076205003774",
 ifsc: "ICIC0000762",
 upi: "anandtutorials@icici",
 upiPhone: "7974221232",
};
